<div class="input-value" [class.clickable]="!readonly">
  <mat-form-field class="static-form" (click)="openDialog()" [floatLabel]="'always'">
    <mat-label>{{inLabel}}</mat-label>
    <input matInput placeholder="กรุณากรอก{{inLabel}}" [value]="inF.value" readonly>
    <!-- <span *ngIf="suffix" matSuffix>{{suffix}}</span> -->
  </mat-form-field>
  <div class="flex-spacer"></div>
  <mat-icon *ngIf="!readonly" color="primary" (click)="openDialog()">edit</mat-icon>
</div>
